module.exports = __webpack_public_path__ + "static/img/so56.73ad523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/so56.png
// module id = SQ67
// module chunks = 0